import { logger } from "bernie-core";
import * as React from "react";
import { LocalizedComponentProps, withLocalization } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";
import { FlexComponent, ModuleDefinition } from "typings/flexFramework/FlexComponent";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { ErrorBoundary } from "components/errorBoundaries/errorBoundaries";

export interface BlossomComponentsProps extends LocalizedComponentProps {
  context: ExtendedContextStore;
  logger?: Logger;
  blossomComponent?: BlossomComponent;
  flexComponents?: FlexComponent[];
  moduleDefinitions?: ModuleDefinition[];
}

/**
 * React component that uses the Blossom Components Factory to render the desired components.
 * It knows how to handle things like a module definition, flex components, composition and a template.
 */
@logger("BlossomComponents")
@withLocalization
export class BlossomComponents extends React.Component<BlossomComponentsProps> {
  public render() {
    if (this.props.blossomComponent) {
      return this.props.blossomComponent.renderChildren(this.props.logger!, this.props.l10n, this.props.context);
    }

    const keyHelper = new ItemKeyHelper("blossomComponent");

    return BlossomComponentsFactory.get(this.props).map((component) => (
      <ErrorBoundary key={component.getId() || keyHelper.next()}>
        {component.render(
          component.getId() || keyHelper.next(),
          this.props.context,
          this.props.l10n,
          this.props.logger!
        )}
      </ErrorBoundary>
    ));
  }
}
